// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"2eda4a4a","641":"2eda4a4a","756":"2eda4a4a","858":"124de5fc","924":"f34041c6","930":"56a5cd41"}[chunkId] + ".chunk.css";
};